import { createRouter, RouterProvider } from '@tanstack/react-router';
import { demoRouteTree } from './demo-routes.tsx';

const demoRouter = createRouter({
  routeTree: demoRouteTree,
  basepath: '/demos',
});

export function DemoApp() {
  return <RouterProvider router={demoRouter} />;
}
